import { render, staticRenderFns } from "./FilterByRate.vue?vue&type=template&id=669b67a6&scoped=true&"
import script from "./FilterByRate.vue?vue&type=script&lang=js&"
export * from "./FilterByRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b67a6",
  null
  
)

export default component.exports